/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zero_Platform_Liability_InstaInputs */

const en_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero Platform Liability. Instant Payouts.`)
};

const es_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cero responsabilidad de plataforma. Pagos instantáneos.`)
};

const fr_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zéro responsabilité de plateforme. Paiements instantanés.`)
};

const de_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Plattformhaftung. Sofortige Auszahlungen.`)
};

const ja_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラットフォーム側の責任ゼロ。即時入金。`)
};

const zh_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平台零责任。即时提现。`)
};

const ar_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انعدام مسؤولية المنصة. مدفوعات فورية.`)
};

const id_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nol Tanggung Jawab Platform. Pembayaran Instan.`)
};

const it_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zero Responsabilità di Piattaforma. Pagamenti Istantanei.`)
};

const ru_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нулевая ответственность платформы. Мгновенные выплаты.`)
};

const pt_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabilidade Zero da Plataforma. Pagamentos Instantâneos.`)
};

const ko_zero_platform_liability_insta = /** @type {(inputs: Zero_Platform_Liability_InstaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랫폼의 법적 책임 제로. 즉각적인 정산.`)
};

/**
* | output |
* | --- |
* | "Zero Platform Liability. Instant Payouts." |
*
* @param {Zero_Platform_Liability_InstaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const zero_platform_liability_insta = /** @type {((inputs?: Zero_Platform_Liability_InstaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zero_Platform_Liability_InstaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_zero_platform_liability_insta(inputs)
	if (locale === "es") return es_zero_platform_liability_insta(inputs)
	if (locale === "fr") return fr_zero_platform_liability_insta(inputs)
	if (locale === "de") return de_zero_platform_liability_insta(inputs)
	if (locale === "ja") return ja_zero_platform_liability_insta(inputs)
	if (locale === "zh") return zh_zero_platform_liability_insta(inputs)
	if (locale === "ar") return ar_zero_platform_liability_insta(inputs)
	if (locale === "id") return id_zero_platform_liability_insta(inputs)
	if (locale === "it") return it_zero_platform_liability_insta(inputs)
	if (locale === "ru") return ru_zero_platform_liability_insta(inputs)
	if (locale === "pt") return pt_zero_platform_liability_insta(inputs)
	return ko_zero_platform_liability_insta(inputs)
});